import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initialState = {
    // TODO need to get this from init param as can default to open
    areVisible: false,
    count: 0,
    highlightedComment: null,
    leaveCommentPopoverVisible: false,
    notification: null,
};
export default function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actionTypes.SET_COMMENT_COUNT:
            return update(state, {
                count: { $set: action.count },
            });
        case actionTypes.SHOW_COMMENTS:
            return update(state, {
                areVisible: { $set: true },
            });
        case actionTypes.HIDE_COMMENTS:
            return update(state, {
                areVisible: { $set: false },
                highlightedComment: { $set: null },
            });
        case actionTypes.HIGHLIGHT_COMMENT:
            return update(state, {
                highlightedComment: { $set: action.id },
            });
        case actionTypes.UNHIGHLIGHT_COMMENT:
            return update(state, {
                highlightedComment: { $set: null },
            });
        case actionTypes.RECEIVE_LEAVE_COMMENT_POPOVER_COOKIE:
            return update(state, {
                leaveCommentPopoverVisible: { $set: !action.value },
            });
        case actionTypes.SHOW_COMMENT_NOTIFICATION:
            return update(state, {
                notification: { $set: action.notification },
                leaveCommentPopoverVisible: { $set: false },
            });
        case actionTypes.HIDE_COMMENT_NOTIFICATION:
            return update(state, {
                notification: { $set: null },
            });
        case actionTypes.LOCATION_CHANGED: {
            var highlightedComment = action.highlightedComment;
            if (highlightedComment) {
                return update(state, {
                    areVisible: { $set: true },
                    highlightedComment: { $set: action.id },
                });
            }
            return update(state, {
                highlightedComment: { $set: null },
            });
        }
        default:
            return state;
    }
}
